import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { useCreateLicenseMutation } from '@/core/services/license'
import { useGetPoliciesQuery } from '@/core/services/policy'

import { getApiErrorMessage } from '@/utils/errors'

import LicenseForm from '../components/LicenseForm'

export default function CreatePolicyForm() {
  const location = useLocation()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const { data: policies } = useGetPoliciesQuery()
  const [createLicense, { isLoading: isCreatingLicense }] = useCreateLicenseMutation()

  const policiesData = useMemo(
    () =>
      policies?.map((policy) => ({
        id: policy._id,
        name: policy.name,
        description: policy.description,
      })),
    [policies]
  )

  return (
    <LicenseForm
      isSubmitting={isCreatingLicense}
      onSubmit={async (values) => {
        try {
          await createLicense(values).unwrap()
          navigate(location.pathname.replace('/create', ''))
        } catch (error) {
          enqueueSnackbar(getApiErrorMessage(error, t('notification.policy.create.error')), { variant: 'error' })
        }
      }}
      policies={policiesData}
    />
  )
}
